export default {
  namespaced: true,
  state: {
    mastertagLogs: [],
    filterMastertagLog: null,
    segmentation: null
  },
  getters: {
    mastertagLogs: (state) => state.mastertagLogs,
    filterMastertagLog: (state) => state.filterMastertagLog,
    mastertagLogSegmentation: (state) => state.segmentation
  },
  mutations: {
    SET_MASTERTAG_LOGS(state, payload) {
      state.mastertagLogs = payload;
    },
    SET_FILTER_MASTERTAG_LOG(state, payload) {
      state.filterMastertagLog = payload;
    },
    SET_MASTERTAG_LOG_SEGMENTATION(state, payload) {
      state.segmentation = payload;
    }
  },
  actions: {
    ActionSetMastertagLogs({ commit }, payload) {
      commit('SET_MASTERTAG_LOGS', payload);
    },
    ActionSetFilterMastertagLog({ commit }, payload) {
      commit('SET_FILTER_MASTERTAG_LOG', payload);
    },
    ActionSetMastertagLogSegmentation({ commit }, payload) {
      commit('SET_MASTERTAG_LOG_SEGMENTATION', payload);
    }
  }
};
